function r() {
  return {
    before(_ref) {
      let {
        doc: e,
        d: o
      } = _ref;
      o.style(e.documentElement, "overflow", "hidden");
    }
  };
}
export { r as preventScroll };